"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumTimeOutData = void 0;
const actions_1 = require("./actions");
exports.TealiumTimeOutData = {
    [actions_1.TIMEOUT_MODAL_WARNING_VIEW]: {
        action: actions_1.TealiumAction.OPEN,
        format: actions_1.TealiumFormat.MODAL,
        component: actions_1.TealiumComponent.TIMEOUT_WARNING,
        element: 'full',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_WARNING,
        eventLabel: 'open',
    },
    [actions_1.TIMEOUT_MODAL_EXPIRED_VIEW]: {
        action: actions_1.TealiumAction.OPEN,
        format: actions_1.TealiumFormat.MODAL,
        component: actions_1.TealiumComponent.TIMEOUT_EXPIRED,
        element: 'full',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_EXPIRED,
        eventLabel: 'open',
    },
    [actions_1.TIMEOUT_MODAL_EXTEND_SESSION_BUTTON]: (pathname) => ({
        pathname,
        action: actions_1.TealiumAction.CONTINUE,
        format: actions_1.TealiumFormat.BUTTON,
        component: actions_1.TealiumComponent.TIMEOUT_WARNING,
        element: 'extendSession',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_WARNING,
        eventLabel: 'modalNavigationExtendSessionButton',
    }),
    [actions_1.TIMEOUT_MODAL_LOGIN_BUTTON]: (pathname) => ({
        pathname,
        action: actions_1.TealiumAction.LOGIN,
        format: actions_1.TealiumFormat.BUTTON,
        component: actions_1.TealiumComponent.TIMEOUT_EXPIRED,
        element: 'logIn',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_EXPIRED,
        eventLabel: 'modalNavigationLogInButton',
    }),
    [actions_1.TIMEOUT_MODAL_LOGOUT_LINK]: {
        action: actions_1.TealiumAction.LOGOUT,
        format: actions_1.TealiumFormat.LINK,
        component: actions_1.TealiumComponent.TIMEOUT_WARNING,
        element: 'logOut',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_WARNING,
        eventLabel: 'modalNavigationLogOutLink',
    },
    [actions_1.TIMEOUT_MODAL_EXIT_LINK]: {
        action: actions_1.TealiumAction.EXIT,
        format: actions_1.TealiumFormat.LINK,
        component: actions_1.TealiumComponent.TIMEOUT_EXPIRED,
        element: 'exit',
        eventCategory: actions_1.PAGE_NAME_TIMEOUT,
        eventAction: actions_1.TealiumEventAction.TIMEOUT_EXPIRED,
        eventLabel: 'modalNavigationExitLink',
    },
};
//# sourceMappingURL=tealium.js.map